import React, { useState, useEffect, useRef } from "react";
import { constants } from "../../config/constants";

const LivePianoSettings = ({
  isTv,
  focusedButton,
  setFocusedButton,
  onClose,
}) => {
  const [autostart, setAutostart] = useState(true);
  const [announcement, setAnnouncement] = useState(true);
  const firstLivePianoButtonRef = useRef(null);

  // Load settings from localStorage on component mount
  useEffect(() => {
    const savedAutostart = localStorage.getItem(constants.LIVE_PIANO_AUTOSTART);
    const savedAnnouncement = localStorage.getItem(
      constants.LIVE_PIANO_ANNOUNCEMENT
    );

    // Default to true (opt-out feature) if not set in localStorage
    setAutostart(savedAutostart !== null ? savedAutostart === "true" : true);
    setAnnouncement(
      savedAnnouncement !== null ? savedAnnouncement === "true" : true
    );
  }, []);

  // Auto-focus first button when component mounts on TV
  useEffect(() => {
    if (firstLivePianoButtonRef.current && isTv) {
      setFocusedButton("live-piano-autostart-toggle");
      firstLivePianoButtonRef.current.focus();
    }
  }, [isTv, setFocusedButton]);

  // Button style with focus handling
  const getButtonStyle = (buttonId, baseStyle) => {
    const focusedStyle =
      isTv && focusedButton === buttonId
        ? {
            border: "6px solid #3ADF3C",
            outline: "none",
          }
        : {};

    return {
      ...baseStyle,
      ...focusedStyle,
    };
  };

  // Exit button style
  const exitButtonStyle = {
    marginLeft: "10px",
    border: isTv ? "6px solid red" : "2px solid red",
    background: "transparent",
    color: "red",
    fontFamily: "Lato",
    fontSize: isTv ? "60px" : "35px",
    padding: isTv ? "10px 25px" : "0px 20px",
    borderRadius: "20px",
    fontWeight: "700",
    margin: "10px 0px",
    cursor: "pointer",
    marginTop: "20px",
  };

  const handleAutostartToggle = () => {
    const newValue = !autostart;
    setAutostart(newValue);
    localStorage.setItem(constants.LIVE_PIANO_AUTOSTART, newValue.toString());
  };

  const handleAnnouncementToggle = () => {
    const newValue = !announcement;
    setAnnouncement(newValue);
    localStorage.setItem(
      constants.LIVE_PIANO_ANNOUNCEMENT,
      newValue.toString()
    );
  };

  return (
    <div>
      {isTv ? (
        // TV interface with buttons
        <>
          <div style={{ display: "flex", gap: "20px", marginBottom: "20px" }}>
            <span
              style={{
                fontSize: "85px",
                color: "blue",
                fontFamily: "Lato",
              }}
            >
              Autostart:
            </span>
            <button
              ref={firstLivePianoButtonRef}
              tabIndex={0}
              onFocus={() => setFocusedButton("live-piano-autostart-toggle")}
              onBlur={() => setFocusedButton(null)}
              onClick={handleAutostartToggle}
              style={getButtonStyle("live-piano-autostart-toggle", {
                background: autostart ? "blue" : "transparent",
                border: "6px solid blue",
                color: autostart ? "white" : "blue",
                fontFamily: "Lato",
                fontSize: "60px",
                padding: "10px 25px",
                borderRadius: "20px",
                fontWeight: "700",
                cursor: "pointer",
              })}
            >
              {autostart ? "ON" : "OFF"}
            </button>
          </div>

          <div style={{ display: "flex", gap: "20px", marginBottom: "40px" }}>
            <span
              style={{
                fontSize: "85px",
                color: "blue",
                fontFamily: "Lato",
              }}
            >
              Announcement:
            </span>
            <button
              tabIndex={0}
              onFocus={() => setFocusedButton("live-piano-announcement-toggle")}
              onBlur={() => setFocusedButton(null)}
              onClick={handleAnnouncementToggle}
              style={getButtonStyle("live-piano-announcement-toggle", {
                background: announcement ? "blue" : "transparent",
                border: "6px solid blue",
                color: announcement ? "white" : "blue",
                fontFamily: "Lato",
                fontSize: "60px",
                padding: "10px 25px",
                borderRadius: "20px",
                fontWeight: "700",
                cursor: "pointer",
              })}
            >
              {announcement ? "ON" : "OFF"}
            </button>
          </div>

          <button
            tabIndex={0}
            onFocus={() => setFocusedButton("live-piano-close")}
            onBlur={() => setFocusedButton(null)}
            onClick={onClose}
            style={getButtonStyle("live-piano-close", exitButtonStyle)}
          >
            Close
          </button>
        </>
      ) : (
        // Original touch interface with checkboxes
        <>
          <div>
            <span
              style={{
                fontSize: "45px",
                color: "blue",
                fontFamily: "Lato",
              }}
            >
              Autostart:{" "}
            </span>
            <input
              style={{
                width: "35px",
                height: "35px",
              }}
              type="checkbox"
              checked={autostart}
              onChange={handleAutostartToggle}
            />
          </div>
          <div
            style={{
              marginTop: 20,
            }}
          >
            <span
              style={{
                fontSize: "45px",
                color: "blue",
                fontFamily: "Lato",
              }}
            >
              Announcement:{" "}
            </span>
            <input
              style={{
                width: "35px",
                height: "35px",
              }}
              type="checkbox"
              checked={announcement}
              onChange={handleAnnouncementToggle}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default LivePianoSettings;
